import React, { memo } from "react";
import { useLocation } from "react-router-dom";

import "./singlePort.scss";

import { Button } from "@mui/material";
import { AiOutlineLink } from "react-icons/ai";

const SinglePort = () => {
  const location = useLocation();
  const { title, image, category, liveLink, gitClient, gitServer, body } =
    location.state;

  return (
    <div className="single-prot">
      <img src={`${image}`} alt={category} />
      <div className="port-text">
        <h1 className="name">{title}</h1>
        <a
          className="live-btn"
          href={liveLink}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button>
            {" "}
            <AiOutlineLink size={17} style={{ marginRight: "5px" }} /> Live Link
          </Button>
        </a>

        <h2 className="title">{title}</h2>
        <div
          className="desc"
          dangerouslySetInnerHTML={{ __html: body.value }}
        ></div>

        <div className="package pkg-client">
          <p>
            On this website, I will use many NPM packages like -{" "}
            <span>Client-Side</span>
          </p>
          <pre className="pkg">{gitClient}</pre>
        </div>
        <div className="package pkg-server">
          <p>
            On this website, I will use many NPM packages like -{" "}
            <span>Server-Side</span>
          </p>
          <pre className="pkg">{gitServer}</pre>
        </div>
      </div>
    </div>
  );
};

export default memo(SinglePort);
